export enum ExportLogErrorStatus {
	LoadingExport,
	SuccessExport,
	AccessDenied,
	GenericError,
}

export enum LogType {
	rbs = 'RecoverBadSectorsLog',
	scan = 'HardwareScanLog',
	snapshot = 'SnapshotLog',
}
